
export const UpcomingWorkationsCarousel = (function () {
	let swiperInstance, prevButton, nextButton = null;
  let SELECTORS = null; // Declare SELECTORS as null initially

  function initSwiper({onItemClick}) {
    const swiperWrapper = document.querySelector(SELECTORS.swiperWrapper);
    const swiperSlides = document.querySelectorAll(SELECTORS.swiperSlides);

    prevButton = document.querySelector(SELECTORS.prevButton);
    nextButton = document.querySelector(SELECTORS.nextButton);

    if (!swiperWrapper || !prevButton || !nextButton || !swiperSlides) {
      console.error('Required elements not found');
      return null;
    }    

    // Initialize Swiper
    const swiper = new Swiper(SELECTORS.swiper, {
      direction: "vertical",
      slidesPerView: "auto",
      spaceBetween: 8,
      freeMode: false,
      navigation: {
        nextEl: SELECTORS.nextButton,
        prevEl: SELECTORS.prevButton,
      },
      watchOverflow: true,
    });

		swiperInstance = swiper;

    // Set initial state of buttons
    updateButtonsState();

    // Add event listeners to update button states when slides change
    swiper.on('slideChange', function () {
      updateButtonsState();
    });
    
    if (onItemClick) {
      swiperSlides.forEach(slide => {
         slide.addEventListener('click', (e) => onItemClick(e.currentTarget));
      });
    }

    return swiper;
  }

  // Function to update button states
  function updateButtonsState() {
  	if (!prevButton || !nextButton) return;
    
    prevButton.style.opacity = swiperInstance.isBeginning ? '0.5' : '1';
    prevButton.style.pointerEvents = swiperInstance.isBeginning ? 'none' : 'auto'; 

		nextButton.style.opacity = swiperInstance.isEnd ? '0.5' : '1';
    nextButton.style.pointerEvents = swiperInstance.isEnd ? 'none' : 'auto';
  }

  // Public methods
  return {
    init: function({selectors, onItemClick}) {
      SELECTORS = selectors;
      document.addEventListener('DOMContentLoaded', function() {
      	const swiperWrapper = document.querySelector(SELECTORS.swiperWrapper);
        swiperWrapper.style.gap = '0';
      	
        // Initialize swiper
        initSwiper({onItemClick});
      });
    }
  };
})();